import MainLayout from '@/shared/Layouts/MainLayout'
import css from './equipment.module.css'
import NavigationBreadcrumbs from 'src/navigation/components/NavigationBreadcrumbs'
import { useMemo, useState } from 'react'
import { TEquipmentTabType } from '@/pages/Equipment/equipment.types.ts'
import Tabs from '@/shared/Tabs'
import equipmentPageConstants from '@/pages/Equipment/equipment.constants.ts'
import EquipmentTab from '@/pages/Equipment/Tabs/EquipmentTab'
import ConnectionRequestsTab from '@/pages/Equipment/Tabs/ConnectionRequestsTab'
import useIsAdmin from '@/pages/User/hooks/useIsAdmin.ts'
import useTitle from '@/shared/hooks/useTitle'

const EquipmentPageContent = () => {
  const isAdmin = useIsAdmin()
  const [selectedTab, setSelectedTab] = useState<TEquipmentTabType>('equipment')

  const renderContent = () => {
    switch (selectedTab) {
      case 'equipment':
        return <EquipmentTab />
      case 'connection-requests':
        return <ConnectionRequestsTab />
    }
  }

  const tabs = useMemo(() => {
    if (!isAdmin) {
      return equipmentPageConstants.cardTabs.filter((t) => t.id !== 'connection-requests')
    }

    return equipmentPageConstants.cardTabs
  }, [isAdmin])

  return (
    <div className={css.wrapper}>
      <div className="flex-lines gap16 height100">
        <NavigationBreadcrumbs />
        <div className="flex-lines gap4">
          <h2 className="text-heading-3">Устройства</h2>
        </div>
        <div className={css.mainCard}>
          <div>
            <Tabs tabs={tabs} onSelect={setSelectedTab as any} selectedTab={selectedTab} />
          </div>
          {renderContent()}
        </div>
      </div>
    </div>
  )
}

const EquipmentPage = () => {
  useTitle('Устройства')
  return (
    <MainLayout>
      <EquipmentPageContent />
    </MainLayout>
  )
}

export default EquipmentPage
